import React from 'react'
import { Link } from 'react-router-dom'
import { ArrowLeft } from '../../../assets/images'
import { LoginWithMobileNumberPayloadType, LoginWithMobileOtpVerifyPayloadType } from '../../../commonTypes/authTypes';

type AppProps = {
    inputDetails: any;
    minutes: number;
    seconds: number;
    countryDialCode: any;
    verifyOtpButton: boolean;
    disabled: boolean;
    isActive: boolean;
    setInputDetails: (data: any) => void;
    setIsActive: (data: boolean) => void;
    setVerifyOtpButton: (data: boolean) => void;
    setDisabled: (data: boolean) => void;
    setSeconds: (data: number) => void;
    handleMobileOtpVerify: (data: LoginWithMobileOtpVerifyPayloadType) => void;
    handleMobileOtpSend: (data: LoginWithMobileNumberPayloadType) => void;
}

const LoginOtpVerification = ({
    inputDetails,
    setInputDetails,
    setIsActive,
    setVerifyOtpButton,
    setSeconds,
    setDisabled,
    handleMobileOtpVerify,
    countryDialCode,
    verifyOtpButton,
    minutes,
    seconds,
    disabled,
    isActive,
    handleMobileOtpSend
}: AppProps) => {
    const handleInputChange = (e: any) => {
        const Value = e.target.value;
        setInputDetails((prev: any) => ({
            ...prev,
            otp: Value
        }))
        if (Value) {
            setIsActive(false)
            setVerifyOtpButton(false)
            setSeconds(0)
            setDisabled(false)
        }
        else {
            setDisabled(true)
            setVerifyOtpButton(true)
        }
    }

    const handleVerifyOtp = () => {
        setDisabled(true)
        setVerifyOtpButton(true)
        setInputDetails((prev: any) => ({
            ...prev,
            otp: ''
        }))
        if (inputDetails?.otp.length === 6) {
            const finalData = {
                countryCode: countryDialCode?.value,
                mobileNumber: inputDetails?.mobileNumber,
                otp: inputDetails?.otp
            }
            handleMobileOtpVerify(finalData)
        }
    }

    const handleMaxLengthCheck = (e: any) => {
        if (e?.target.value.length > e?.target.maxLength) {
            e.target.value = e.target.value.slice(0, e.target.maxLength);
            setInputDetails((prev: any) => ({
                ...prev,
                otp: e?.target.value
            }))
        }
    };

    const handleResendOtp = () => {
        setIsActive(true)
        let finalData = {
            countryCode: countryDialCode?.value,
            mobileNumber: inputDetails?.mobileNumber
        }
        handleMobileOtpSend(finalData)
    }

    const blank = () => {

    }

    return (
        <>
            <div className='mt-5'>
                <span>
                    <span></span>
                    <Link to='/' className='back-to-login'><img src={ArrowLeft} />Back to Login</Link>
                    <h5 className='mt-3 mb-2'>Verify Mobile Number</h5>
                    <p className='description'>We have successfully sent 6 digit OTP to your number. Please enter below to verify your identity.</p>
                </span>
                <div className="form-group mt-3">
                    <div>
                        <label htmlFor="otp"
                        >OTP</label>
                        <input
                            type="number"
                            name='otp'
                            className='form-control'
                            value={inputDetails?.otp}
                            placeholder='6 digit OTP'
                            autoFocus
                            onChange={handleInputChange}
                            maxLength={6}
                            onInput={handleMaxLengthCheck}
                            onWheel={event => event.currentTarget.blur()}
                        />
                    </div>
                </div>
                <div className="mb-3 mt-4">
                    <button type="submit" className="btn btn-primary w-100"
                        disabled={inputDetails?.otp.length < 6 || verifyOtpButton}
                        onClick={handleVerifyOtp}
                    >
                        Verify & Login
                    </button>
                </div>
                <div style={{ textAlign: 'center' }}>
                    <p className='mt-4 mb-1'>Didn’t receive OTP?</p>
                    {isActive && <span className='resend-link'>Resend OTP in {minutes <= 9 ? "0" : ""}{minutes}:{seconds <= 9 ? "0" : ""}{seconds}</span>}
                    {!isActive && <span style={{ color: '#dd4433', marginTop: "-15px", cursor: disabled ? "pointer" : "not-allowed" }}
                        onClick={verifyOtpButton ? handleResendOtp : blank}>Resend OTP</span>}
                </div>
            </div>
        </>
    )
}

export default LoginOtpVerification